<template>
    <div class="poweredby-container">
        <span>by Teknisa™</span>
    </div>
</template>
<script >
export default {
  name: 'PoweredBy'
}
</script>
<style lang="less" scoped>
.poweredby-container {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background:#000;
    height: 30px;
    display: block;
    text-align: center;
    color: #fff;
    span {
        display: block;
        margin: auto;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        position: absolute;
        background-color: #565656;
        color: transparent;
        text-shadow: 2px 2px 3px rgba(150,150,150,0.2);
        -webkit-background-clip: text;
        -moz-background-clip: text;
        background-clip: text;
        font-weight: bold;
    }
}
</style>
